"use client";

import { AuthShell } from "@/components/auth/auth-shell";
import { RouteErrorBoundary } from "@/components/states/route-error";

/**
 * Error boundary for the auth screens (login/signup/reset). Renders the shell
 * itself now that the layout is a pass-through, so a failed screen still lands
 * on the shell canvas rather than a bare page.
 */
export default function AuthError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <AuthShell>
      <RouteErrorBoundary
        {...props}
        source="boundary:(auth)"
        description="We couldn't load this screen. Please try again."
      />
    </AuthShell>
  );
}
